import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';
import DataTable from '@/containers/data_table_ml/DataTable';
import { fieldPackageStatus } from '@/constants.js';
import Action from '../action/Action';
import { history } from 'umi';

const TablePage = (props) => {
  const { loadingstatus, tableData, fetchData } = props || {};
  const handleDetail = (record) => {
    history.push({
      pathname: '/bre/fm/tvf/cfg',
      query: {
        id: record.id,
        name: record.fieldName,
        editable: record.editable,
      },
    });
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    {
      title: '变量类型',
      dataIndex: 'fieldPackageName',
      key: 'fieldPackageName',
      width: 100,
      render: () => '临时变量',
    },
    {
      title: '临时变量名称',
      dataIndex: 'fieldName',
      key: 'fieldName',
      width: 200,
      render: (text, record) => (
        <TableLinkML text={text} handleClick={() => handleDetail(record)} />
      ),
    },
    {
      title: '变量名',
      dataIndex: 'variableName',
      key: 'variableName',
      width: 130,
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: 100,
    },
    {
      title: '默认值',
      dataIndex: 'defaultValue',
      key: 'defaultValue',
      width: 70,
    },
    {
      title: '异常值',
      dataIndex: 'exceptionValue',
      key: 'exceptionValue',
      width: 70,
    },
    {
      title: '字段描述',
      dataIndex: 'description',
      key: 'description',
      width: 200,
    },
    {
      title: '状态',
      dataIndex: 'fieldStatus',
      key: 'fieldStatus',
      width: 70,
      render: (text) => {
        return fieldPackageStatus[text];
      },
    },
    {
      title: '操作',
      // fixed: 'right',
      render: (record) => {
        return <Action singleListInfo={record} fetchData={fetchData} />;
      },
      width: 185,
    },
  ];
  return (
    <DataTable
      className="demo-test"
      // style={{ minWidth: '1547px' }}
      columns={columns}
      rowSelection={false}
      // pagination={pagination}
      scroll={{
        x: '1247px',
        y: 'calc(100vh - 64px - 46px - 47px - 60px - 2rem)',
      }}
      loading={loadingstatus}
      dataSource={tableData}
      // changePage={(a) => {
      //   props.pageNumChange(a);
      // }}
      // changePageSize={(a) => {
      //   props.pageSizeChange(a);
      // }}
    />
  );
};
export default TablePage;
